import { Box, VStack, Text, Button, theme } from '@bpba/ui-components';
import { useState } from 'react';




export const PopupInicio: React.FC = () => {

  const [displayModalInterno, setDisplayModalInterno] = useState<boolean>(true);
  return (
    <>
      <Box width={"auto"} display={["none", "none", "flex", "flex"]} position={"fixed"} justifyContent={"flex-end"} right={0} overflow={"hidden"} 
          zIndex={"3"}>

        <VStack
          width={"400px"}
          height={"220px"}
          backgroundColor={theme.colors.white}
          borderRadius={['3px 20px']}
          marginBottom={['1rem']}
          justifyContent={"space-between"}
          padding={"20px"}
          style={{boxShadow:"0px 6px 8px #00000029", display: displayModalInterno ? 'flex' : 'none' }}
          
        >

          <Box
            flex={'flex'}
            justifyContent={'space-between'}
            overflow={'hidden'}
            borderTopRightRadius={'20px'}
          >

            <Box maxWidth={"319px"} >
              <Text fontSize={'22px'} lineHeight={'27px'} fontWeight={'400'} color={theme.colors.secondary[1]} margin={0} tabIndex={0}>
                ¡Escaneá el código para descargar la app!
              </Text>
            </Box>

            <Box width={"40px"} marginTop={"-30px"}>
              <Button
                backgroundColor={'transparent'}
                style={{ width: '30px', border: 'none', borderRadius: '2px 7px' }}>
                <a href={"#"} style={{ textDecoration: "none", color: "#58585a", fontWeight: 'bold', fontSize: "28px", fontFamily: "encode_sansregular, sans-serif" }} tabIndex={0} aria-label={"Oprima acá para cerrar el popup"} onClick={() => { setDisplayModalInterno(!displayModalInterno); }}>&times;</a>
              </Button>
            </Box>

          </Box>

          <Box width={"100%"} display={'flex'} flexDirection={'row'} alignItems={"center"}>
            <img src='/CDN/Get/LogoCuentaDNIComercios' width="179px" height={"64px"}></img>

            <img src="/CDN/Get/CDNI_QR" style={{ width: "126px", height: "126px", }}></img>
          </Box>


        </VStack>



      </Box>

    </>
  );
};
